module.exports = __webpack_public_path__ + "red.8a7fcb3059b48ade0948.png";